export default __webpack_public_path__ + "static/media/to-the-point.94cb2d55.ogg";